import React from 'react';
import { defineMessages } from 'react-intl';
import Confirm from 'components/Confirm';
import Message from 'components/Message';

const messages = defineMessages({
  title: {
    id: 'ratings.remove-studio-response-confirmation-modal.body',
    defaultMessage: 'Are you sure you want to delete your reply?',
  },
  cancel: {
    id: 'ratings.remove-studio-response-confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'ratings.remove-studio-response-confirmation-modal.yes',
    defaultMessage: 'Yes',
  },
});

const RemoveStudioResponseConfirmationModal = props => (
  <Confirm
    subtitle={<Message message={messages.title} />}
    cancelNode={<Message message={messages.cancel} />}
    acceptNode={<Message message={messages.confirm} />}
    {...props}
  />
);

export default RemoveStudioResponseConfirmationModal;
